import { useState } from 'react';
import { Link } from 'react-router-dom';
import alluminium from '../assets/alluminium2.png';
import herobg from '../assets/bg.jpg';
import bricks from '../assets/bricks2.jpg';
import Cmixer from '../assets/Concrete_mixer.jpeg';
import mixer from '../assets/concretemixer.jpg';
import exc from '../assets/exca.jpg';
import fire1 from '../assets/fireext1.webp';
import gravel from '../assets/gravel.jpg';
import gypsum from '../assets/gypsum1.jpg';
import C_mixer from '../assets/jigu.jpeg';
import kit from '../assets/kit.webp';
import plate from '../assets/platecompactor.jpg';
import pipe from '../assets/pvcpipes.jpg';
import sand from '../assets/sand2.jpg';
import scaffoldig from '../assets/scaffolding.jpg';
import steel from '../assets/steel2.png';
import cement from '../assets/twiga.jpg';
import valve from '../assets/valved.jpg';
import valveo from '../assets/valveo.jpg';
import wheelbarrowing from '../assets/wheelbarrow.jpg';


const productsData = {
  supply: [
    { id: 1, name: 'Cement', description: 'Premium-grade cement suitable for all structural and finishing works.', image: cement },
    { id: 2, name: 'Fire Extinguisher', description: 'Certified fire extinguisher suitable for homes, offices, and commercial buildings.', image: fire1 },
    { id: 3, name: 'Bricks', description: 'Durable, high-strength bricks ideal for building walls and foundations.', image: bricks },
    { id: 4, name: 'Double Outlet Landing Valve', description: 'High-quality double outlet landing valve for fire hydrant systems.', image: valve },
    { id: 5, name: 'Steel Rods', description: 'High-tensile steel reinforcement bars for structural construction.', image: steel },
    { id: 6, name: 'Oblique Type Landing Valve', description: 'Durable oblique-type landing valve used in firefighting water systems.', image: valveo },
    { id: 7, name: 'Sand', description: 'Clean, fine-quality river sand for plastering and concrete works.', image: sand },
    { id: 8, name: 'Gravel', description: 'Premium crushed stone aggregates for concrete and drainage projects.', image: gravel },
    { id: 9, name: 'PVC Pipes', description: 'Reliable, long-lasting PVC pipes for plumbing and water systems.', image: pipe },
    { id: 10, name: 'Aluminium Windows & Doors', description: 'Modern aluminium frames offering durability, security, and style.', image: alluminium },
    { id: 11, name: 'Gypsum Board', description: 'Lightweight gypsum boards for ceilings, partitions, and interior finishing.', image: gypsum },
    { id: 12, name: 'Standard First Aid Kit', description: 'Comprehensive first aid kit equipped for emergency treatment.', image: kit },
  ],

  rent: [
    { id: 1, name: 'Excavator', description: 'Heavy-duty excavator designed for digging, loading, and earth-moving operations.', image: exc },
    { id: 2, name: 'Concrete Mixer', description: 'Portable concrete mixer used to achieve consistent mixing for construction works.', image: mixer },
    { id: 3, name: 'Scaffolding', description: 'Sturdy and secure scaffolding for elevated construction and maintenance tasks.', image: scaffoldig },
    { id: 4, name: 'Wheelbarrow', description: 'Heavy-duty wheelbarrow for transporting construction materials easily.', image: wheelbarrowing },
    { id: 5, name: 'Plate Compactor', description: 'Reliable plate compactor suitable for soil and gravel compaction.', image: plate },
    { id: 6, name: 'Concrete Mixer (Large)', description: 'High-capacity concrete mixer ideal for large construction projects.', image: Cmixer },
    { id: 7, name: 'Concrete Mixer (Electric)', description: 'Efficient electric-powered mixer suitable for medium-scale construction tasks.', image: C_mixer },
  ],
};

function Products() {
  const [category, setCategory] = useState('supply');

  return (
    <div className="w-full">
      
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Shop from us</h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white">Home</Link>
            <span>/</span>
            <Link to="/products" className="underline hover:text-white">Products</Link>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-12 flex flex-col gap-8">

        <aside className="bg-gray-100 shadow-md max-w-lg rounded-xl p-6">
          <h2 className="text-xl font-bold mb-4 text-gray-700 border-b pb-2">Categories</h2>

          {/* Mobile: Stacked | Desktop: Side-by-side */}
          <div className="flex flex-col md:flex-row gap-3">
            <button
              className={`w-full px-4 py-2 rounded-lg transition-all duration-200 
                ${category === 'supply'
                  ? 'bg-primary text-white font-semibold shadow'
                  : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              onClick={() => setCategory('supply')}
            >
              🏗️ Materials Supply
            </button>

            <button
              className={`w-full px-4 py-2 rounded-lg transition-all duration-200 
                ${category === 'rent'
                  ? 'bg-primary text-white font-semibold shadow'
                  : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              onClick={() => setCategory('rent')}
            >
              🚜 Equipment Rent
            </button>
          </div>
        </aside>


        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {productsData[category].map((product) => (
            <Link
              to={`/products/${category}/${product.id}`}
              key={product.id}
              className="rounded-sm overflow-hidden bg-white shadow hover:shadow-lg transition"
            >
              <img
                src={product.image}
                alt={product.name}
                loading="lazy"
                className="h-60 w-full object-cover"
              />

              <div className="p-3 bg-primary">
                <h3 className="text-lg font-semibold text-secondary text-center">
                  {product.name}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export { productsData };
export default Products;
